// extracted by mini-css-extract-plugin
export var dataCell = "_qq-2";
export var dataRow = "_qq-0";
export var headerRow = "_qq-1";